import { Button } from "@maker/design-system/ui/button";
import { useState } from "react";
import { useParamsOrThrow } from "../../../../../hooks/use-params-or-throw";
import { useTranscriptionData } from "../../../../../hooks/use-transcriptions";
import { formatTimecode } from "../../../../../utils/time";
import { TranscriptionsTranscriptionVideo } from "../_elements/video";

const TranscriptionsTranscriptionTextPage = () => {
	const { id } = useParamsOrThrow<"id">();
	const data = useTranscriptionData(id);
	const [videoTime, setVideoTime] = useState(0);

	return (
		<div className="h-full flex-1 grid-cols-1 overflow-hidden md:grid md:grid-cols-12">
			<div className="md:col-span-5 md:h-full">
				<div className="border-neutral-100 border-r bg-neutral-50 p-6 md:h-full">
					<TranscriptionsTranscriptionVideo
						src={data.url}
						currentTime={videoTime}
					/>
				</div>
			</div>

			<div className="h-full overflow-y-auto md:col-span-7">
				<div className="p-6">
					{data.transcription.segments.map((item, index) => (
						<div className="mb-2.5" key={index}>
							<div className="mb-0.5 inline-flex items-center gap-1 font-medium text-xs">
								<span className="font-semibold">
									{
										data.transcription.speakers.find(
											(speaker) => speaker.id === item.words[0]?.speaker_id,
										)?.name
									}
								</span>

								<span className="text-2xs text-neutral-500">•</span>

								<span className="text-2xs text-neutral-500">
									{item.words[0]?.start
										? formatTimecode(item.words[0].start)
										: ""}
								</span>
							</div>

							<div className="leading-3">
								{item.words.map((item, index) =>
									item.type === "word" ? (
										<Button
											className="rounded-none font-normal text-neutral-600 text-sm hover:text-neutral-900"
											text="black"
											onClick={() => setVideoTime(item.start)}
											key={`${item.start}-${index}`}
										>
											{item.text}
										</Button>
									) : (
										<span className="text-sm" key={`${item.start}-${index}`}>
											{item.text}
										</span>
									),
								)}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default TranscriptionsTranscriptionTextPage;
